import { Navigate, useNavigate } from "react-router-dom";
import "./receivingManagement.css";
import { clearActiveTab } from "../../../../redux/features/TabsManager/tabSlice";
import { useDispatch } from "react-redux";
import { NavBar } from "../../../../components/NavBar/NavBar";
import { Checkbox, FormControlLabel, FormGroup, Link } from "@mui/material";
import { Sorting } from "../../../../components/Lists/Sorting";
import { useEffect, useRef, useState } from "react";
import { ReceivingItem } from "./ReceivingItem/ReceivingItem";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";
import { dropdownConfig } from "../../../../services/dropdownsConfigService";
import Skeleton from "react-loading-skeleton";
import Dropdowns from "../../../../components/Dropdowns/Dropdowns";
import { SortingHeader } from "../../../../components/Sorting/SortingHeader";
import { SortingProvider } from "../../../../contexts/SortingContext";
import { SortingButton } from "../../../../components/Sorting/SortingButton";
import {
  createFiltersConfig,
  FiltersManager,
} from "../../../../components/FiltersManager/FiltersManager";
import { getOrdersReceiveList } from "../../Services/receivingManagementService";
import { environment } from "../../../../environments/environment";
import { ResultsNotFound } from "../../../../components/ResultsNotFound/ResultsNotFound";
import { localStorageGet } from "../../../../services/localStorageService";
const receivingDraftPrefix = "store/receiving/draft/";

export const ReceivingManagement = () => {
  const getCompanyFilter = () => {
    let companiesId = JSON.parse(localStorage.getItem("u_companies")).map(
      (e) => {
        return e.id;
      }
    );
    return {
      columnName: "company_id",
      value: companiesId,
    };
  };

  const buildFilterBody = (filters = []) => {
    const filtered = filters.filter(
      (item) => item && item.columnName !== "company_id"
    );

    return [getCompanyFilter(), ...filtered];
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dataBreadCrumbs = [
    <Link
      key={1}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => {
        dispatch(clearActiveTab());
        Navigate("/secure/customdashboard");
      }}
    >
      Modules
    </Link>,
    <Link
      key={2}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => {
        dispatch(clearActiveTab());
        navigate("/secure/store");
      }}
    >
      Store
    </Link>,
    <Link
      key={3}
      underline="none"
      sx={{ color: "#000000", cursor: "default", fontSize: "var(--p-size)" }}
    >
      Receiving Management
    </Link>,
  ];
  const [itemsList, setItemsList] = useState([]);
  const [draftList, setDraftList] = useState([]);
  const [allItemsList, setAllItemsList] = useState([]);

  const [openedFilters, setOpenedFilters] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, SetPageSize] = useState(10);
  const [maxPages, setMaxPages] = useState(0);
  const [sortingOrder, setSortingOrder] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [body, setBody] = useState(buildFilterBody());

  // dropdowns configs to filters
  const [conditionDrop, setConditionDrop] = useState(null);
  const [orderTypeDrop, setOrderTypeDrop] = useState(null);
  const [orderNumber, setOrderNumberDrop] = useState(null);
  const [locationDrop, setLocationDrop] = useState(null);
  const [sitesDrop, setSitesDrop] = useState(null);
  const [vendorsDrop, setVendorsDrop] = useState(null);
  const [priorityDrop, setPriorityDrop] = useState(null);
  const [AWBDrop, setAWBDrop] = useState(null);
  const [companyDrop, setCompanyDrop] = useState(null);
  const [supplyChainUserDrop, setSupplyChainUserDrop] = useState(null);
  const [ACDrop, setACDrop] = useState(null);
  const [WPDrop, setWPDrop] = useState(null);
  const [PRNDrop, setPRNDrop] = useState(null);
  const [PNDrop, setPNDrop] = useState(null);
  const [SNDrop, setSNDrop] = useState(null);
  const [companyDropData, setCompanyDropData] = useState([]);

  // dropdowns states to delete single options
  const [orderTypeOptionToDelete, setOrderTypeOptionToDelete] = useState(null);
  const [workPackageIdOptionToDelete, setWorkPackageIdOptionToDelete] =
    useState(null);
  const [vendorIdOptionToDelete, setVendorIdOptionToDelete] = useState(null);
  const [awbIdOptionToDelete, setAwbIdOptionToDelete] = useState(null);
  const [locationIdOptionToDelete, setLocationIdOptionToDelete] =
    useState(null);
  const [companyIdOptionToDelete, setCompanyIdOptionToDelete] = useState(null);
  const [priorityOptionToDelete, setPriorityOptionToDelete] = useState(null);
  const [parentOrderIdOptionToDelete, setParentOrderIdOptionToDelete] =
    useState(null);
  const [siteIdOptionToDelete, setSiteIdOptionToDelete] = useState(null);
  const [aircraftIdOptionToDelete, setAircraftIdOptionToDelete] =
    useState(null);
  const [partIdOptionToDelete, setPartIdOptionToDelete] = useState(null);
  const [supplyChainOptionToDelete, setSupplyChainOptionToDelete] =
    useState(null);
  const [prnOptionToDelete, setPrnOptionToDelete] = useState(null);
  const [conditionOptionToDelete, setConditionOptionToDelete] = useState(null);

  // dropdowns parameters
  const [dropdownsCompanyParameters, setDropdownsCompanyParameters] = useState([
    { columnName: "companyId", value: localStorage.getItem("u_company_id") },
  ]);

  //dropdowns filters selected
  const [orderType, setOrderType] = useState(null);
  const [parentOrderId, setParentOrderId] = useState(null);
  const [locationId, setLocationId] = useState(null);
  const [siteId, setSiteId] = useState(null);
  const [vendorId, setVendorId] = useState(null);
  const [priority, setPriority] = useState(null);
  const [awbId, setAwbId] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [supplyChain, setSupplyChain] = useState(null);
  const [aircraftId, setAircraftId] = useState(null);
  const [workPackageId, setWorkPackageId] = useState(null);
  const [condition, setCondition] = useState(null);
  const [partId, setPartId] = useState(null);
  const [prn, setPrn] = useState(null);
  // const [ordersReceived, setOrdersReceived] = useState(false);
  // const [sn, setSn] = useState(null);

  // dropdowns preselection
  // dropdowns filters preselect
  const [preselectOrderType, setPreselectOrderType] = useState(null);
  const [preselectParentOrderId, setPreselectParentOrderId] = useState(null);
  const [preselectLocationId, setPreselectLocationId] = useState(null);
  const [preselectSiteId, setPreselectSiteId] = useState(null);
  const [preselectVendorId, setPreselectVendorId] = useState(null);
  const [preselectPriority, setPreselectPriority] = useState(null);
  const [preselectAwbId, setPreselectAwbId] = useState(null);
  const [preselectCompanyId, setPreselectCompanyId] = useState(null);
  const [preselectSupplyChain, setPreselectSupplyChain] = useState(null);
  const [preselectAircraftId, setPreselectAircraftId] = useState(null);
  const [preselectWorkPackageId, setPreselectWorkPackageId] = useState(null);
  const [preselectCondition, setPreselectCondition] = useState(null);
  const [preselectPartId, setPreselectPartId] = useState(null);
  const [preselectPrn, setPreselectPrn] = useState(null);
  // const [preselectOrdersReceived, setPreselectOrdersReceived] = useState(null);
  // const [preselectSn, setPreselectSn] = useState(null);

  const debounceRef = useRef(null);

  // functions
  const clearAllFilters = () => {
    setOrderType(null);
    setParentOrderId(null);
    setLocationId(null);
    setSiteId(null);
    setVendorId(null);
    setPriority(null);
    setAwbId(null);
    setCompanyId(null);
    setSupplyChain(null);
    setAircraftId(null);
    setWorkPackageId(null);
    setCondition(null);
    setPartId(null);
    setPrn(null);

    setPreselectOrderType(null);
    setPreselectParentOrderId(null);
    setPreselectLocationId(null);
    setPreselectSiteId(null);
    setPreselectVendorId(null);
    setPreselectPriority(null);
    setPreselectAwbId(null);
    setPreselectCompanyId(null);
    setPreselectSupplyChain(null);
    setPreselectAircraftId(null);
    setPreselectWorkPackageId(null);
    setPreselectCondition(null);
    setPreselectPartId(null);
    setPreselectPrn(null);

    const emptyBody = buildFilterBody([]);
    setBody(emptyBody);
    getOrdersList(0, pageSize, searchValue, sortingOrder, false, emptyBody);
  };

  const getDropdownConfigCondition = async () => {
    let id = 126;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setConditionDrop(request.data.load);
    }
  };
  const getDropdownConfigOrderType = async () => {
    let id = 112;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setOrderTypeDrop(request.data.load);
    }
  };

  const getDropdownConfigCompany = async () => {
    let id = 91;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setCompanyDrop(request.data.load);
    }
  };

  const getDropdownConfigPRN = async () => {
    let id = 104;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setPRNDrop(request.data.load);
    }
  };

  const getDropdownConfigPN = async () => {
    let id = 1;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setPNDrop(request.data.load);
    }
  };

  const getDropdownConfigSN = async () => {
    let id = 100;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setSNDrop(request.data.load);
    }
  };

  const getDropdownConfigLocation = async () => {
    let id = 87;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setLocationDrop(request.data.load);
    }
  };

  const getDropdownConfigSites = async () => {
    let id = 102;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setSitesDrop(request.data.load);
    }
  };

  const getDropdownConfigVendors = async () => {
    let id = 127;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setVendorsDrop(request.data.load);
    }
  };

  const getDropdownConfigAC = async () => {
    let id = 88;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setACDrop(request.data.load);
    }
  };

  const getDropdownConfigWP = async () => {
    let id = 93;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setWPDrop(request.data.load);
    }
  };

  const getDropdownConfigPriority = async () => {
    let id = 113;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setPriorityDrop(request.data.load);
    }
  };
  const getDropdownConfigOrderNumber = async () => {
    let id = 116;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setOrderNumberDrop(request.data.load);
    }
  };

  const getDropdownConfigAWB = async () => {
    let id = 117;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setAWBDrop(request.data.load);
    }
  };

  const getDropdownConfigSupplyChainUser = async () => {
    let id = 119;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setSupplyChainUserDrop(request.data.load);
    }
  };

  const getAllDropdowns = async () => {
    const results = await Promise.all([
      getDropdownConfigCondition(),
      getDropdownConfigAC(),
      getDropdownConfigAWB(),
      getDropdownConfigCompany(),
      getDropdownConfigCondition(),
      getDropdownConfigLocation(),
      getDropdownConfigSites(),
      getDropdownConfigSN(),
      getDropdownConfigSupplyChainUser(),
      getDropdownConfigOrderNumber(),
      getDropdownConfigPriority(),
      getDropdownConfigOrderType(),
      getDropdownConfigWP(),
      getDropdownConfigVendors(),
      getDropdownConfigPN(),
      getDropdownConfigPRN(),
    ]);

    return results;
  };

  const idRegistry = new Map();
  let globalCounter = 0;

  const getStableUniqueId = (item, idx = 0) => {
    const baseKey = `${item.id}-${idx}`;

    if (!idRegistry.has(baseKey)) {
      globalCounter++;
      idRegistry.set(baseKey, `uid-${globalCounter}`);
    }

    return idRegistry.get(baseKey);
  };

  const getOrdersList = async (
    p = 0,
    ps = pageSize,
    search = "",
    orderBy = sortingOrder,
    isScroll = false,
    filters
  ) => {
    setLoading(true);
    try {
      const draftList = localStorageGet(receivingDraftPrefix, {});
      let request = await getOrdersReceiveList(p, ps, search, orderBy, filters);
      if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
        setMaxPages(request.data.totalPages);
        if (!isScroll) {
          setPage(1);
          const expandedItems = request.data.load.flatMap((item) => {
            if (item.category === "Serialized" && item.quantity > 1) {
              return Array.from({ length: item.quantity }, (_, idx) => ({
                ...item,
                awb_id: item.awb_id,
                quantity: 1,
                __unique_serial_id: `${item.id}-${
                  idx + 1
                }-${crypto.randomUUID()}`,
                //  __unique_serial_id: getStableUniqueId(item, idx),
              }));
            }
            return [
              {
                ...item,
                __unique_serial_id: `${item.id}-${crypto.randomUUID()}`,
                //  __unique_serial_id: getStableUniqueId(item, idx),
              },
            ];
          });
          setItemsList(expandedItems);
        } else {
          setDraftList(draftList);
          setPage((prevPage) => prevPage + 1);
          const expandedItems = request.data.load.flatMap((item) => {
            if (item.category === "Serialized" && item.quantity > 1) {
              return Array.from({ length: item.quantity }, (_, idx) => ({
                ...item,
                awb_id: item.awb_id,
                quantity: 1,
                __unique_serial_id: `${item.id}-${idx + 1}-${crypto.randomUUID()}`,
                //  __unique_serial_id: getStableUniqueId(item, idx),
              }));
            }
            return [
              {
                ...item,
                __unique_serial_id: `${item.id}-${crypto.randomUUID()}`,
                // __unique_serial_id: getStableUniqueId(item, idx),
              },
            ];
          });

          setItemsList((prevItems) => [...prevItems, ...expandedItems]);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const combineItems = () => {
    const itemsDraft = draftList.length > 0 ? draftList : [];

    const uniqueItems = itemsDraft.filter((el) => {
      !itemsList.some((e) => e.__unique_serial_id === el.__unique_serial_id);
    });

    setAllItemsList([...uniqueItems, ...itemsList]);
  };

  useEffect(() => {
    combineItems();
  }, [draftList, itemsList]);
  const handleOrderReceived = () => {
    getOrdersList(0, pageSize, "", sortingOrder, false, body);
  };

  const rawFilters = {
    order_type: {
      selected: orderType,
      setSelected: setOrderType,
      setPreselect: setPreselectOrderType,
      setToDelete: setOrderTypeOptionToDelete,
      getDisplay: (item) => item.name,
    },
    parent_order_id: {
      selected: parentOrderId,
      setSelected: setParentOrderId,
      setPreselect: setPreselectParentOrderId,
      setToDelete: setParentOrderIdOptionToDelete,
      getDisplay: (item) => item.id,
    },
    location_id: {
      selected: locationId,
      setSelected: setLocationId,
      setPreselect: setPreselectLocationId,
      setToDelete: setLocationIdOptionToDelete,
      getDisplay: (item) => item.code,
    },
    site_id: {
      selected: siteId,
      setSelected: setSiteId,
      setPreselect: setPreselectSiteId,
      setToDelete: setSiteIdOptionToDelete,
      getDisplay: (item) => item.name,
    },
    vendor_id: {
      selected: vendorId,
      setSelected: setVendorId,
      setPreselect: setPreselectVendorId,
      setToDelete: setVendorIdOptionToDelete,
      getDisplay: (item) => item.name,
    },
    priority: {
      selected: priority,
      setSelected: setPriority,
      setPreselect: setPreselectPriority,
      setToDelete: setPriorityOptionToDelete,
      getDisplay: (item) => item.name,
    },
    awb_id: {
      selected: awbId,
      setSelected: setAwbId,
      setPreselect: setPreselectAwbId,
      setToDelete: setAwbIdOptionToDelete,
      getDisplay: (item) => item.awb_number,
    },
    company_id: {
      selected: companyId,
      setSelected: setCompanyId,
      setPreselect: setPreselectCompanyId,
      setToDelete: setCompanyIdOptionToDelete,
      getDisplay: (item) => item.name,
    },
    supply_chain: {
      selected: supplyChain,
      setSelected: setSupplyChain,
      setPreselect: setPreselectSupplyChain,
      setToDelete: setSupplyChainOptionToDelete,
      getDisplay: (item) => item.name,
    },
    aircraft_id: {
      selected: aircraftId,
      setSelected: setAircraftId,
      setPreselect: setPreselectAircraftId,
      setToDelete: setAircraftIdOptionToDelete,
      getDisplay: (item) => item.tail,
    },
    work_package_id: {
      selected: workPackageId,
      setSelected: setWorkPackageId,
      setPreselect: setPreselectWorkPackageId,
      setToDelete: setWorkPackageIdOptionToDelete,
      getDisplay: (item) => item.code,
    },
    condition: {
      selected: condition,
      setSelected: setCondition,
      setPreselect: setPreselectCondition,
      setToDelete: setConditionOptionToDelete,
      getDisplay: (item) => item.name,
    },
    part_id: {
      selected: partId,
      setSelected: setPartId,
      setPreselect: setPreselectPartId,
      setToDelete: setPartIdOptionToDelete,
      getDisplay: (item) => item.part_number,
    },
    prn: {
      selected: prn,
      setSelected: setPrn,
      setPreselect: setPreselectPrn,
      setToDelete: setPrnOptionToDelete,
      getDisplay: (item) => item.code,
    },

    // sn: {
    //   selected: sn,
    //   setSelected: setSn,
    //   setPreselect: setPreselectSn,
    //   setToDelete: setSnOptionToDelete,
    //   getDisplay: (item) => item.code,
    // },
  };

  const filtersConfig = createFiltersConfig(
    rawFilters,
    setBody,
    getOrdersList,
    [0, pageSize, searchValue, sortingOrder, false]
  );

  const getDropdownClearHandler = (columnName, setSelected) => () => {
    setSelected([]);
    setBody((prev) =>
      buildFilterBody(prev.filter((item) => item.columnName !== columnName))
    );
  };

  const handleSearchOfOrders = () => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      getOrdersList(0, pageSize, searchValue, sortingOrder, false, body);
    }, environment.debounceTime);
  };

  useEffect(() => {
    getOrdersList(0, pageSize, searchValue, sortingOrder, false, body);
  }, [sortingOrder]);

  useEffect(() => {
    getOrdersList(0, pageSize, searchValue, sortingOrder, false, body);
  }, [body]);

  useEffect(() => {
    if (!openedFilters) return;

    const filters = [
      orderType?.length > 0 && {
        columnName: "order_type",
        value: orderType.map((e) => e.id),
      },
      parentOrderId?.length > 0 && {
        columnName: "parent_order_id",
        value: parentOrderId.map((e) => e.id),
      },
      locationId?.length > 0 && {
        columnName: "location_id",
        value: locationId.map((e) => e.id),
      },
      siteId?.length > 0 && {
        columnName: "site_id",
        value: siteId.map((e) => e.id),
      },
      vendorId?.length > 0 && {
        columnName: "vendor_id",
        value: vendorId.map((e) => e.id),
      },
      priority?.length > 0 && {
        columnName: "priority",
        value: priority.map((e) => e.name),
      },
      awbId?.length > 0 && {
        columnName: "awb_id",
        value: awbId.map((e) => e.id),
      },
      companyId?.length > 0 && {
        columnName: "company_id",
        value: companyId.map((e) => e.id),
      },
      supplyChain?.length > 0 && {
        columnName: "supply_chain",
        value: supplyChain.map((e) => e.id),
      },
      aircraftId?.length > 0 && {
        columnName: "aircraft_id",
        value: aircraftId.map((e) => e.id),
      },
      workPackageId?.length > 0 && {
        columnName: "work_package_id",
        value: workPackageId.map((e) => e.id),
      },
      condition?.length > 0 && {
        columnName: "condition",
        value: condition.map((e) => e.name),
      },
      partId?.length > 0 && {
        columnName: "part_id",
        value: partId.map((e) => e.id),
      },
      prn?.length > 0 && {
        columnName: "prn",
        value: prn.map((e) => e.id),
      },
    ].filter(Boolean);

    const newBody = buildFilterBody(filters);

    if (JSON.stringify(newBody) !== JSON.stringify(body)) {
      setBody(newBody);
      getOrdersList(0, pageSize, searchValue, sortingOrder, false, newBody);
    }
  }, [
    openedFilters,
    orderType,
    parentOrderId,
    locationId,
    siteId,
    vendorId,
    priority,
    awbId,
    companyId,
    supplyChain,
    aircraftId,
    workPackageId,
    condition,
    partId,
    prn,
  ]);

  useEffect(() => {
    if (openedFilters) {
      setCompanyDropData(() => JSON.parse(localStorage.getItem("u_companies")));
      getAllDropdowns();
    }
  }, [openedFilters]);

  useEffect(() => {
    getOrdersList(page, pageSize, "", sortingOrder, false, body);
  }, []);

  useEffect(() => {
    handleSearchOfOrders();
  }, [searchValue]);

  const setcionOrderListRef = useRef(null);

  const handleScroll = () => {
    const section = setcionOrderListRef.current;
    if (section) {
      const { scrollTop, scrollHeight, clientHeight } = section;
      if (scrollTop + clientHeight >= scrollHeight - 2) {
        getMoreOrders();
      }
    }
  };

  const getMoreOrders = () => {
    if (loading || page >= maxPages) {
      return;
    }
    getOrdersList(page, pageSize, searchValue, sortingOrder, true, body);
  };

  useEffect(() => {
    const section = setcionOrderListRef.current;
    if (section) {
      section.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (section) {
        section.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  const handleSortingFiltersChange = (fullSelectedMap) => {
    setBody((prevBody) => {
      const updatedBody = [...prevBody];

      Object.entries(fullSelectedMap).forEach(([columnName, fullSelected]) => {
        const existingIndex = updatedBody.findIndex(
          (f) => f.columnName === columnName
        );

        if (!fullSelected || fullSelected.length === 0) {
          if (existingIndex !== -1) {
            updatedBody.splice(existingIndex, 1);
          }

          if (columnName === "order_type") {
            setOrderType([]);
          } else if (columnName === "parent_order_id") {
            setParentOrderId([]);
          } else if (columnName === "part_number") {
            setPartId([]);
          } else if (columnName === "location") {
            setLocationId([]);
          } else if (columnName === "site") {
            setSiteId([]);
          } else if (columnName === "vendor") {
            setVendorId([]);
          }

          return;
        }

        const valuesOnly = fullSelected.map((item) => {
          if (columnName === "order_type") return item.id;
          if (columnName === "parent_order_id") return item.id;
          if (columnName === "part_id") return item.id;
          if (columnName === "location_id") return item.id;
          if (columnName === "site_id") return item.id;
          if (columnName === "vendor_id") return item.id;

          return item;
        });

        if (existingIndex !== -1) {
          updatedBody[existingIndex].value = valuesOnly;
        } else {
          updatedBody.push({ columnName, value: valuesOnly });
        }

        if (columnName === "order_type") {
          setOrderType(fullSelected);
        } else if (columnName === "parent_order_id") {
          setParentOrderId(fullSelected);
        } else if (columnName === "part_id") {
          setPartId(fullSelected);
        } else if (columnName === "location_id") {
          setLocationId(fullSelected);
        } else if (columnName === "site_id") {
          setSiteId(fullSelected);
        } else if (columnName === "vendor_id") {
          setVendorId(fullSelected);
        }
      });

      getOrdersList(0, pageSize, searchValue, sortingOrder, false, updatedBody);

      return updatedBody;
    });
  };
  return (
    <SortingProvider
      onOrderChange={setSortingOrder}
      showHeaderOrder={true}
      properties={{
        id: "LN",
        order_type: "Order Type",
        parent_order_id: "Order Number",
        part_id: "PN",
        category: "Category",
        quantity_order: "QTY Ordered",
        quantity: "Remaining QTY",
        Description: "Description",
        // serial_number: "SN",
        location_id: "Location",
        site_id: "Site",
        vendor_id: "Vendor",
        supply_chain: "Supply Chain User",
        company_name: "Company",
      }}
      columnFilterProperties={{
        order_type: 112,
        parent_order_id: 116,
        part_id: 1,

        location_id: 87,
        site_id: 102,
        vendor_id: 127,
        // supply_chain: 119,
        // company_name: 91
      }}
    >
      <section className="receiving-management">
        <section
          className="receiving-nav"
          style={{
            height: openedFilters ? "15rem" : "5.5rem",
          }}
        >
          <NavBar
            dataBreadCrumbs={"/store/receiving"}
            appIcon={"icon-part_request_icon"}
            // moduleIcon={"icon-settings"}
            moduleColor="#0077FF"
            title={"Receiving Management"}
            menuTitle={"Store"}
            moduleId={3}
            currentPath={"store/orders-management"}
            previousPath={"/store"}
            isLocalSearch={true}
            searchInputProps={{
              type: "text",
              onTextChange: (e) => setSearchValue(e),
            }}
            searchActions={
              <>
                <FiltersManager
                  appliedFilters={body}
                  onFilterChange={setBody}
                  handleClearAllFilters={clearAllFilters}
                  onButtonClick={() => setOpenedFilters(!openedFilters)}
                  excludeColumns={["company_id"]}
                  onClearGroup={(col) => filtersConfig[col]?.clearGroup?.()}
                  onDeleteFilter={(col, val) =>
                    filtersConfig[col]?.deleteValue?.(val)
                  }
                  getFilterLabel={(col) => filtersConfig[col]?.label || col}
                  getDisplayValue={(col, val) =>
                    filtersConfig[col]?.getDisplayValue(val) || val
                  }
                />
                <SortingButton></SortingButton>
              </>
            }
            // goBackData={goBackDataObj}
          >
            {/* <div className="receiving-management-header-cont">
                            <button onClick={() => {
                                setOpenedFilters(!openedFilters)
                            }}>
                                Filters
                                <i className="icon-arrow-down"></i>
                            </button>
                        </div> */}
          </NavBar>

          <section
            className="receiving-filters-section"
            style={{
              transition: "var(--transition)",
              height: openedFilters ? "11rem" : "0",
              visibility: openedFilters ? "visible" : "hidden",
            }}
          >
            <div>
              {orderTypeDrop ? (
                <Dropdowns
                  data={orderTypeDrop}
                  onApplySelection={(e) => {
                    setOrderType(e);
                    setPreselectOrderType(undefined);
                  }}
                  deleteSingleOption={orderTypeOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectOrderType}
                  handleClear={getDropdownClearHandler(
                    "order_type",
                    setOrderType
                  )}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div>
              {orderNumber ? (
                <Dropdowns
                  data={orderNumber}
                  parameters={dropdownsCompanyParameters}
                  onApplySelection={(e) => {
                    setParentOrderId(e);
                    setPreselectParentOrderId(undefined);
                  }}
                  deleteSingleOption={parentOrderIdOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectParentOrderId}
                  handleClear={getDropdownClearHandler(
                    "parent_order_id",
                    setParentOrderId
                  )}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div>
              {locationDrop ? (
                <Dropdowns
                  data={locationDrop}
                  onApplySelection={(e) => {
                    setLocationId(e);
                    setPreselectLocationId(undefined);
                  }}
                  deleteSingleOption={locationIdOptionToDelete}
                  columnSingleDelete={"id"}
                  optionsSelectedColumnName={"code"}
                  preSelectValue={preselectLocationId}
                  handleClear={getDropdownClearHandler(
                    "location_id",
                    setLocationId
                  )}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div>
              {sitesDrop ? (
                <Dropdowns
                  data={sitesDrop}
                  onApplySelection={(e) => {
                    setSiteId(e);
                    setPreselectSiteId(undefined);
                  }}
                  deleteSingleOption={siteIdOptionToDelete}
                  columnSingleDelete={"id"}
                  optionsSelectedColumnName={"site_code"}
                  preSelectValue={preselectSiteId}
                  handleClear={getDropdownClearHandler("site_id", setSiteId)}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div>
              {vendorsDrop ? (
                <Dropdowns
                  data={vendorsDrop}
                  parameters={dropdownsCompanyParameters}
                  onApplySelection={(e) => {
                    setVendorId(e);
                    setPreselectVendorId(undefined);
                  }}
                  deleteSingleOption={vendorIdOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectVendorId}
                  handleClear={getDropdownClearHandler(
                    "vendor_id",
                    setVendorId
                  )}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div>
              {priorityDrop ? (
                <Dropdowns
                  data={priorityDrop}
                  onApplySelection={(e) => {
                    setPriority(e);
                    setPreselectPriority(undefined);
                  }}
                  deleteSingleOption={priorityOptionToDelete}
                  columnSingleDelete={"name"}
                  preSelectValue={preselectPriority}
                  handleClear={getDropdownClearHandler("priority", setPriority)}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div>
              {PNDrop ? (
                <Dropdowns
                  data={PNDrop}
                  onApplySelection={(e) => {
                    setPartId(e);
                    setPreselectPartId(undefined);
                  }}
                  deleteSingleOption={partIdOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectPartId}
                  handleClear={getDropdownClearHandler("part_id", setPartId)}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div>
              {companyDrop ? (
                <Dropdowns
                  data={companyDrop}
                  isStatic={true}
                  staticData={companyDropData}
                  onApplySelection={(e) => {
                    setCompanyId(e);
                    setPreselectCompanyId(undefined);
                  }}
                  deleteSingleOption={companyIdOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectCompanyId}
                  handleClear={getDropdownClearHandler(
                    "company_id",
                    setCompanyId
                  )}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div>
              {AWBDrop ? (
                <Dropdowns
                  data={AWBDrop}
                  onApplySelection={(e) => {
                    setAwbId(e);
                    setPreselectAwbId(undefined);
                  }}
                  deleteSingleOption={awbIdOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectAwbId}
                  handleClear={getDropdownClearHandler("awb_id", setAwbId)}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div>
              {supplyChainUserDrop ? (
                <Dropdowns
                  data={supplyChainUserDrop}
                  isStatic={true}
                  onApplySelection={(e) => {
                    setSupplyChain(e);
                    setPreselectSupplyChain(undefined);
                  }}
                  deleteSingleOption={supplyChainOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectSupplyChain}
                  handleClear={getDropdownClearHandler(
                    "supply_chain",
                    setSupplyChain
                  )}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div>
              {ACDrop ? (
                <Dropdowns
                  data={ACDrop}
                  onApplySelection={(e) => {
                    setAircraftId(e);
                    setPreselectAircraftId(undefined);
                  }}
                  deleteSingleOption={aircraftIdOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectAircraftId}
                  handleClear={getDropdownClearHandler(
                    "aircraft_id",
                    setAircraftId
                  )}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div>
              {WPDrop ? (
                <Dropdowns
                  data={WPDrop}
                  onApplySelection={(e) => {
                    setWorkPackageId(e);
                    setPreselectWorkPackageId(undefined);
                  }}
                  deleteSingleOption={workPackageIdOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectWorkPackageId}
                  handleClear={getDropdownClearHandler(
                    "work_package_id",
                    setWorkPackageId
                  )}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div>
              {PRNDrop ? (
                <Dropdowns
                  data={PRNDrop}
                  onApplySelection={(e) => {
                    setPrn(e);
                    setPreselectPrn(undefined);
                  }}
                  deleteSingleOption={prnOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectPrn}
                  handleClear={getDropdownClearHandler("prn", setPrn)}
                />
              ) : (
                <Skeleton height={"2rem"} />
              )}
            </div>

            <div
              // style={{
              //     display: "flex",
              //     backgroundColor: "#DFF5EB",
              //     border: "1px solid #50D999",
              //     borderRadius: "calc(var(--button-radius) - .2rem)",
              // }}
              className="container-check-checked"
            >
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label={<p>Received Orders</p>}
                />
              </FormGroup>
            </div>

            <div>
              <button
                className="reciving-clear-all-btn"
                onClick={clearAllFilters}
              >
                Clear All
              </button>
            </div>
          </section>
        </section>

        <span
          style={{
            marginLeft: "auto",
          }}
        >
          {/* <SortingButton></SortingButton> */}
        </span>
        <section
          className="receiving-content"
          style={{
            height: openedFilters ? "65%" : "100%",
          }}
        >
          <div className="receiving-sorting-container">
            <SortingHeader
              showHeaderOrder={true}
              valuesExtractor={{
                order_type: (items) => items.map((i) => i.id),
                parent_order_id: (items) => items.map((i) => i.id),
                part_id: (items) => items.map((i) => i.id),
                location_id: (items) => items.map((i) => i.id),
                site_id: (items) => items.map((i) => i.id),
                vendor_id: (items) => items.map((i) => i.id),
              }}
              onFiltersSelected={(newFiltersArray, fullSelectedMap) => {
                handleSortingFiltersChange(fullSelectedMap);
              }}
              filtersParameters={{
                vendor_id: dropdownsCompanyParameters,
                parent_order_id: dropdownsCompanyParameters,
              }}
            />
          </div>
          <div className="receiving-list-container" ref={setcionOrderListRef}>
            {allItemsList.length == 0 ? (
              <ResultsNotFound></ResultsNotFound>
            ) : (
              allItemsList.map((i, idx) => (
                <ReceivingItem
                  key={i.__unique_serial_id || i.id}
                  data={i}
                  reload={handleOrderReceived}
                />
              ))
            )}
          </div>
        </section>
      </section>
    </SortingProvider>
  );
};
